import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cap-info-table-skeleton',
  templateUrl: './info-table-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoTableSkeletonComponent {
}
